import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './assets/css/index.css';
import routes from './routes';
import ThemeProvider from 'providers/ThemeProvider';
import './utils/i18n';
import { BrowserRouter } from 'react-router-dom';
import { ServiceProvider } from 'providers/ServiceProvider';
import AuthApolloProvider from 'apollo/AuthApolloProvider';
import AuthProvider from 'providers/AuthenticationProvider';
import LogoutProvider from 'providers/LogoutProvider';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <AuthProvider>
    <AuthApolloProvider>
      <ServiceProvider>
        <ThemeProvider>
          <LogoutProvider>
            <BrowserRouter>{routes}</BrowserRouter>
          </LogoutProvider>
        </ThemeProvider>
      </ServiceProvider>
    </AuthApolloProvider>
  </AuthProvider>
);
